<div [formGroup]="settingForm">
  <p-card styleClass="w-100 mt-2 mb-3 shadow-sm">
    <ng-template pTemplate="header">
      Audit Field Mapping
    </ng-template>
    <div class="p-fluid p-formgrid row audit-enabled-radio">
      <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12">
        <label for="db_audit_enabled" class="intake-form-labels">Audit Field Enabled</label>
        <div class="clearfix">
          <div *ngFor="let category of auditEnabledList" class="field-checkbox">
            <p-radioButton [inputId]="category.key" name="audit_enabled" [value]="category.value"
              formControlName="audit_enabled" [(ngModel)]="auditEnabled"></p-radioButton>
            <label [for]="category.key">{{category.key}}</label>
          </div>
        </div>
      </div>
      <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="settingForm.value.audit_enabled">
        <label for="db_created_by" class="intake-form-labels">Created By</label>
        <input id="db_created_by" aria-labelledby="template" class="form-control" type="text"
          formControlName="created_by" placeholder="Enter DB Created BY" pInputText />
      </div>
      <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="settingForm.value.audit_enabled">
        <label for="db_created_at" class="intake-form-labels">Created At</label>
        <input id="db_created_at" aria-labelledby="template" class="form-control" type="text"
          formControlName="created_at" placeholder="Enter DB Created At" pInputText />
      </div>
      <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="settingForm.value.audit_enabled">
        <label for="db_updated_by" class="intake-form-labels">Updated By</label>
        <input id="db_updated_by" aria-labelledby="template" class="form-control" type="text"
          formControlName="updated_by" placeholder="Enter DB Updated By" pInputText />
      </div>
      <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="settingForm.value.audit_enabled">
        <label for="db_updated_at" class="intake-form-labels">Updated At</label>
        <input id="db_updated_at" aria-labelledby="template" class="form-control" type="text"
          formControlName="updated_at" placeholder="Enter DB Updated At" pInputText />
      </div>
      <div class="p-field col-lg-4 col-sm-4 col-md-12 col-12" *ngIf="settingForm.value.audit_enabled">
        <label for="db_soft_delete" class="intake-form-labels">Soft Delete</label>
        <input id="db_soft_delete" aria-labelledby="template" class="form-control" type="text"
          formControlName="soft_delete" placeholder="Enter DB Soft Delete" pInputText />
      </div>
    </div>
  </p-card>

  <div class="p-fluid p-formgrid row">
    <div class="p-field col-md-12 col-12 text-md-right">
      <button class="mb-2 btn bg-white text-primary btncancel" (click)="cancel()">
        Cancel
      </button>
      <button *ngIf="userid && isEdit === false" class="mb-2 btn btn-primary btncommon" (click)="editStatus()">
        {{'Edit'}}
      </button>
      <button *ngIf="userid && isEdit === true" class="mb-2 btn btn-primary btncommon" (click)="addUser()">
        {{'Update'}}
      </button>
    </div>
  </div>
</div>
